import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=09fdb79c&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09fdb79c')) {
      api.createRecord('09fdb79c', component.options)
    } else {
      api.reload('09fdb79c', component.options)
    }
    module.hot.accept("./ModalHeader.vue?vue&type=template&id=09fdb79c&", function () {
      api.rerender('09fdb79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ModalHeader.vue"
export default component.exports